import { graphql } from "@opensea/graphql"
import { MintModuleFragment } from "@/components/collection/drops/components/MintModule/MintModule.fragment"
import { ContentBlockModuleFragment } from "../components/ContentBlockModule/ContentBlockModule.fragment"
import { FeaturedCollectionsCarouselFragment } from "../components/ContentBlockModule/components/FeaturedCollectionsCarousel/FeaturedCollectionsCarousel.fragment"
import { FeaturedItemsCarouselFragment } from "../components/ContentBlockModule/components/FeaturedItemsCarousel/FeaturedItemsCarousel.fragment"
import { FreeformContentBlockSlideFragment } from "../components/ContentBlockModule/components/FreeformContentBlockSlide/FreeformContentBlockSlide.fragment"
import { TimelineContentBlockCarouselFragment } from "../components/ContentBlockModule/components/TimelineContentBlockCarousel/TimelineContentBlockCarousel.fragment"
import { FaqModuleFragment } from "../components/FaqModule/FaqModule.fragment"
import { NarrativeModuleFragment } from "../components/NarrativeModule/NarrativeModule.fragment"
import { TeamModuleFragment } from "../components/TeamModule/TeamModule.fragment"
import { getMediaPropsFromMediaFragment } from "../utils"

export const CollectionOverviewModulesFragment = graphql(
  `
    fragment CollectionOverviewModules on Collection {
      ...MintModule
      slug
      overview {
        modules {
          __typename
          ... on CollectionNarrativeModule {
            ...NarrativeModule
            id
            title
            description
            variant
            horizontalTextPosition
            verticalTextPosition
            media {
              ...MediaProps
            }
          }
          ... on CollectionFAQModule {
            ...FaqModule
            title
            description
            questions: sections {
              question
              answer
            }
          }
          ... on CollectionTeamModule {
            ...TeamModule
            title
            description
            sections {
              id
              name
              title
              bio
              teamMedia: media {
                ...MediaProps
              }
            }
          }
          ... on CollectionContentBlockModule {
            ...ContentBlockModule
            id
            title
            description
            sections {
              __typename
              ... on DefaultContentBlock {
                ...FreeformContentBlockSlide
                title
                description
                contentMedia: media {
                  ...MediaProps
                }
              }
              ... on FeatureContentBlock {
                id
                itemId
                collectionSlug
              }
              ... on TimelineContentBlock {
                title
                description
                date
                timelineMedia: media {
                  ...MediaProps
                }
              }
            }
          }
        }
      }
    }
  `,
  [
    ContentBlockModuleFragment,
    FaqModuleFragment,
    NarrativeModuleFragment,
    MintModuleFragment,
    TeamModuleFragment,
    getMediaPropsFromMediaFragment,
    FreeformContentBlockSlideFragment,
    TimelineContentBlockCarouselFragment,
    FeaturedCollectionsCarouselFragment,
    FeaturedItemsCarouselFragment,
  ],
)
